export default __webpack_public_path__ + "static/media/hero-level-6-chars-desk.fc01e3eb.webp";